import styled from 'styled-components';

import {Device} from '../../../constants';

const ThumbContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 300px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 100;
  padding-bottom: 80px;

  @media screen and ${Device.mobileL} {
    height: 250px;
  }
`;

export default ThumbContainer;
